import React, { useState, useEffect } from 'react';
import './Header.css';
import CTA from './CTA';
import ME from '../../assets/maaz-profile.jpg';
import HeaderSocials from './HeaderSocials';

// Mirrors the LinkedIn headline so search engines and visitors see the same positioning.
const ROLES = [
  'Software Engineer (Gold Medalist 🥇)',
  'Full Stack Engineer',
  'AI Solutions Architect',
  'Agentic Workflow Automation',
  'RAG & Data Pipelines',
  'Voice AI & LLM Integrations',
  'MERN Stack & n8n',
  'Architecting Scalable AI Infrastructure',
];

const Header = () => {
  const [displayed, setDisplayed] = useState('');
  const [roleIndex, setRoleIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    // Array.from keeps emoji intact while typing (substring would split surrogate pairs).
    const chars = Array.from(ROLES[roleIndex]);
    const speed = isDeleting ? 60 : 110;

    const timer = setTimeout(() => {
      if (!isDeleting) {
        setDisplayed(chars.slice(0, charIndex + 1).join(''));
        setCharIndex(c => c + 1);
        if (charIndex + 1 === chars.length) {
          setTimeout(() => setIsDeleting(true), 1800);
        }
      } else {
        setDisplayed(chars.slice(0, charIndex - 1).join(''));
        setCharIndex(c => c - 1);
        if (charIndex - 1 === 0) {
          setIsDeleting(false);
          setRoleIndex(r => (r + 1) % ROLES.length);
        }
      }
    }, speed);

    return () => clearTimeout(timer);
  }, [charIndex, isDeleting, roleIndex]);

  return (
    <section id='home'>
      <header>
        <div className="container header__container">
          <h5>Hello I'm</h5>
          <h1>Syed Maaz Saeed</h1>
          <h5 className="text-light typewriter">
            {displayed}<span className="typewriter__cursor">|</span>
          </h5>
          <CTA />
          <HeaderSocials />
          <div className="me">
            <img src={ME} alt="Syed Maaz Saeed, AI Solutions Architect and Full Stack Engineer" fetchpriority="high" />
          </div>
          <a href="#contact" className='scroll__down'>Scroll Down</a>
        </div>
      </header>
    </section>
  );
};

export default Header;
